import React from 'react';

export default function SupportLink() {
  return (
    <div className="mt-10">
      <a
        href="mailto:support@wininvest.com"
        className="text-sm transition-colors duration-200"
        style={{ color: 'rgba(255,255,255,0.5)' }}
        onMouseEnter={e => { e.currentTarget.style.color = '#D4A520'; }}
        onMouseLeave={e => { e.currentTarget.style.color = 'rgba(255,255,255,0.5)'; }}
      >
        Need help? Contact support@wininvest.com
      </a>
    </div>
  );
}
